import React, { useContext, useState } from 'react'
import { Interview } from './interview'
import { Event } from './event'
import { useNavigate } from 'react-router-dom'
import { ProjectContext } from '@/context/ProjectContext'
import { cn } from '@/lib/utils'
import { DashboardContext } from '@/context/DashboardContext'

export function Interviews() {
  const { project, sessions } = useContext(ProjectContext)
  const { upcomingMeetings } = useContext(DashboardContext)
  const projectUpcomingMeetings = upcomingMeetings.filter((meeting) => meeting.project_id === project.id)
  const navigate = useNavigate()

  return (
    <div className="w-full pb-[28px] border-b border-[#e4e4e4]">
      <p className="text-[#3f424a] text-[22px] font-bold font-['DM_Sans'] leading-relaxed">Meetings</p>
      <p className="mb-[16px] text-[#62708d] text-base font-medium font-['Manrope'] leading-[23px]">
        Upcoming and recent meetings.
      </p>

      {projectUpcomingMeetings.length > 0 && (
        <>
          <p className="text-[#62708d] text-xs font-extrabold font-['Manrope'] uppercase leading-[13.20px] tracking-wide">
            Upcoming
          </p>
          <div className="mt-[8px] mb-[14px] flex flex-col gap-[8px]">
            {projectUpcomingMeetings.map((meeting) => (
              <Event key={meeting.id} event={meeting} />
            ))}
          </div>
        </>
      )}

      <p className="text-[#62708d] text-xs font-extrabold font-['Manrope'] uppercase leading-[13.20px] tracking-wide">
        Recent
      </p>
      <div className="my-[8px] flex flex-col gap-[8px]">
        {sessions.map((meet) => (
          <button
            key={meet.id}
            onClick={() => (meet.processing ? null : navigate(`/dashboard/meetings/${meet.id}`))}
            className={cn(
              'w-[360px] h-[79.37px] p-4 bg-white rounded-lg shadow border border-grey-200 justify-start items-center gap-4 inline-flex',
              meet.processing && 'opacity-50 cursor-progress'
            )}
          >
            <Interview meet={meet} />
          </button>
        ))}
      </div>
    </div>
  )
}
